var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"uk-modal-close uk-close",attrs:{"href":"#close","aria-hidden":"true"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }